import { ResolutionsComponent } from './parts'

export const Resolutions = () => {
  return <ResolutionsComponent />
}
export default Resolutions
